export const FILTER_FIELDS = Object.freeze({
  TICKET_STATUS: 'ticketStatus',
  DATE_RANGE: 'dateRange',
  IDENTIFIER: 'identifier',
  BUSINESS_IDS: 'businessIds',
  EXCLUDE_BUSINESSES: 'excludeBusinesses',
  SELECTED_BRAND_OPTIONS: 'selectedBrandOptions',
  HAS_SEARCHED: 'hasSearched',
  SORT_ORDER: 'sortOrder',
  PARTIAL_MATCH: 'partialMatch',
});
